module.exports = __webpack_public_path__ + "img/dalina_lopez.bd823ad3.png";